module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-right-top-stone-path-background-remnants.2e4274e3.png";